<div class="vorlagen-container">

  <!-- HEADER -->
  <div class="page-header">
    <div class="header-left">
      <button mat-icon-button type="button" (click)="zurueck()" matTooltip="Zurück zur Inbetriebnahme">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div>
        <h1 class="page-title">
          <mat-icon class="title-icon">view_column</mat-icon>
          Strukturvorlagen
        </h1>
        <div class="page-sub">
          Wiederverwendbare Spaltenstrukturen für manuell erstellte Inbetriebnahmelisten.
          Eine Vorlage enthält nur Spalten, Datentypen, Pflichtfelder, Reihenfolge und die
          Kennzeichnungsspalte – keine Messstellen und keine Prüfergebnisse.
        </div>
      </div>
    </div>

    <div class="header-aktionen" *ngIf="canEdit">
      <button mat-stroked-button type="button" (click)="neueListe()">
        <mat-icon>playlist_add</mat-icon>
        Leere Liste erstellen
      </button>
      <button mat-raised-button color="primary" type="button" (click)="neu()" [disabled]="!!entwurf">
        <mat-icon>add</mat-icon>
        Neue Vorlage
      </button>
    </div>
  </div>


  <!-- BEARBEITEN / NEU -->
  <mat-card class="entwurf-card" *ngIf="entwurf as e">
    <mat-card-content>

      <h2 class="entwurf-titel">
        <mat-icon>{{ e.id == null ? 'add_box' : 'edit' }}</mat-icon>
        {{ e.id == null ? 'Neue Vorlage' : 'Vorlage bearbeiten' }}
      </h2>

      <p class="hinweis" *ngIf="e.id != null">
        Änderungen gelten nur für Listen, die künftig aus dieser Vorlage erstellt werden.
        Bereits erstellte Listen behalten ihre eigene Struktur.
      </p>

      <div class="entwurf-felder">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Vorlagenname</mat-label>
          <input matInput [(ngModel)]="e.name" maxlength="200" required [disabled]="speichert"
            placeholder="z. B. Standard Messstellen KKS">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Beschreibung (optional)</mat-label>
          <input matInput [(ngModel)]="e.beschreibung" maxlength="1000" [disabled]="speichert"
            placeholder="Wofür eignet sich diese Struktur?">
        </mat-form-field>

        <div class="feld-typ">
          <span class="feld-typ-label">Art der Liste</span>
          <mat-button-toggle-group [(ngModel)]="e.listenTyp" [disabled]="speichert" aria-label="Art der Liste">
            <mat-button-toggle *ngFor="let t of listenTypen" [value]="t.wert">{{ t.text }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <app-struktur-editor [struktur]="e.struktur" [disabled]="speichert"
        (strukturChange)="entwurfStruktur($event)" (gueltigChange)="entwurfGueltig($event)">
      </app-struktur-editor>

      <div class="pflege-fehler" *ngIf="entwurfFehler">
        <mat-icon inline>error_outline</mat-icon> {{ entwurfFehler }}
      </div>

      <div class="entwurf-aktionen">
        <button mat-raised-button color="primary" type="button" [disabled]="!kannSpeichern" (click)="speichern()">
          <mat-icon>save</mat-icon>
          {{ e.id == null ? 'Vorlage anlegen' : 'Vorlage speichern' }}
        </button>
        <mat-spinner diameter="22" *ngIf="speichert"></mat-spinner>
        <button mat-button type="button" (click)="abbrechen()" [disabled]="speichert">Abbrechen</button>
      </div>

    </mat-card-content>
  </mat-card>


  <!-- LADEN / FEHLER -->
  <div class="loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <mat-card class="hint-card" *ngIf="loadError">
    <mat-card-content>{{ loadError }}</mat-card-content>
  </mat-card>


  <!-- KEINE VORLAGEN -->
  <mat-card class="hint-card" *ngIf="!isLoading && !loadError && vorlagen.length === 0 && !entwurf">
    <mat-card-content>
      <p>Noch keine Vorlagen vorhanden.</p>
      <p class="hint-sub" *ngIf="canEdit">
        Über <strong>Neue Vorlage</strong> eine Struktur anlegen – oder beim Erstellen einer Liste
        mit eigener Struktur „Als Vorlage speichern“ anhaken.
      </p>
    </mat-card-content>
  </mat-card>


  <!-- LISTE DER VORLAGEN -->
  <ng-container *ngIf="!isLoading && !loadError && vorlagen.length > 0">

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="suche" *ngIf="vorlagen.length > 5">
      <mat-label>Vorlage suchen</mat-label>
      <input matInput [(ngModel)]="suche" placeholder="Name, Beschreibung oder Spalte">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="vorlagen-liste">

      <mat-card class="vorlage-card" *ngFor="let v of gefiltert; trackBy: trackByVorlage"
        [class.vorlage-card-bearbeitet]="entwurf?.id === v.id">
        <mat-card-content>

          <div class="vorlage-kopf">

            <button type="button" class="vorlage-toggle" (click)="umschalten(v)" [attr.aria-expanded]="offen.has(v.id)">
              <mat-icon>{{ offen.has(v.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
              <span class="vorlage-name">{{ v.name }}</span>
            </button>

            <span class="vorlage-meta">
              <span class="meta-chip">{{ listenTypText(v.listenTyp) }}</span>
              <span class="meta-chip">{{ v.spaltenCount }} Spalte{{ v.spaltenCount === 1 ? '' : 'n' }}</span>
              <span class="meta-chip meta-chip-kennz">
                <mat-icon inline>key</mat-icon> {{ kennzeichnungVon(v) }}
              </span>
            </span>

            <span class="vorlage-aktionen" *ngIf="canEdit">
              <button mat-icon-button type="button" (click)="neueListe(v)" matTooltip="Leere Liste aus dieser Vorlage erstellen">
                <mat-icon>playlist_add</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="bearbeiten(v)" [disabled]="!!entwurf" matTooltip="Bearbeiten">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="duplizieren(v)" [disabled]="dupliziertId != null"
                matTooltip="Duplizieren">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-icon-button type="button" color="warn" (click)="loeschen(v)" [disabled]="loeschtId != null"
                matTooltip="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </span>

          </div>

          <p class="vorlage-beschreibung" *ngIf="v.beschreibung">{{ v.beschreibung }}</p>

          <div class="vorlage-details" *ngIf="offen.has(v.id)">
            <app-struktur-vorschau [struktur]="v.struktur"></app-struktur-vorschau>

            <div class="vorlage-fuss">
              Erstellt {{ v.erstelltAmUtc | date:'dd.MM.yyyy' }}
              <ng-container *ngIf="v.erstelltVon">· {{ v.erstelltVon }}</ng-container>
              <ng-container *ngIf="v.geaendertAmUtc">
                · geändert {{ v.geaendertAmUtc | date:'dd.MM.yyyy' }}
                <ng-container *ngIf="v.geaendertVon">· {{ v.geaendertVon }}</ng-container>
              </ng-container>
            </div>
          </div>

        </mat-card-content>
      </mat-card>

    </div>

    <p class="hinweis" *ngIf="gefiltert.length === 0">Keine Vorlage passt zur Suche.</p>

  </ng-container>

</div>
